module.exports = __webpack_public_path__ + "img/L_323_327.a5cb0242.png";